<template>
  <div class="back-http403">
    <div class="left-style">
      <img class="img-style" :src="img403" alt="403">
    </div>
    <div class="right-style">
      <div class="word-403">
        403
      </div>
      <div class="word-info">
        没有权限访问该页面<br>
        请点击以下按钮返回首页
      </div>
      <div class="button-style">
        <el-button class="button-goback" type="primary" @click="goHomepage" plain round>返回首页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import img403 from 'qunji-common-vue-pc/src/assets/403_images/403.png'

export default {
  data () {
    return {
      img403
    }
  },
  methods: {
    goHomepage () {
      this.$router.push({path: '/'})
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .back-http403 {
    background:#F1F3F6;
    width: 100%;
    height: 100%;
  }
  .left-style {
    float: left;
    background:#F1F3F6;
    width: 60%;
    height: 100%;
  }
  .right-style {
    float: left;
    background:#F1F3F6;
    width: 40%;
    height: 100%;
  }
  .img-style {
    margin-top: 94px;
    margin-left: 264px;
  }
  .word-403 {
    width:116px;
    height:50px;
    font-size:64px;
    font-family:MicrosoftYaHei;
    color: #9D9D9D;
    line-height:30px;
    margin-top: 236px;
    margin-right: 185px;
  }
  .word-info {
    width:160px;
    height:43px;
    font-size:14px;
    font-family:MicrosoftYaHei;
    color: #666666;
    line-height:28px;
    margin-top: 30px;
  }
  .button-style{
    margin-top: 33px;
  }
  .button-goback{
    width: 90px !important;
    height: 28px !important;
    line-height: 14px !important;
    font-size: 14px;
    font-family:MicrosoftYaHei;
    background-color: #F1F3F6 !important;
    border: 1px solid #3082F1 !important;
    border-radius: 20px !important;
    color: #3082F1 !important;
    &:hover,
    &:focus {
      color: #fff !important;
      border-color:  mix(#fff, #2562E0, 20%) !important;
      background-color:  mix(#fff, #2562E0, 20%) !important;
    }

    &:active {
      color: #fff !important;
      border-color: #2562E0 !important;
      background-color: #2562E0 !important;
      outline: none;
    }
  }
</style>
